import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { DeleteTheWillModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const DeleteTheWillModal: FC<DeleteTheWillModalProps> = ({ onDelete }) => {
  const { t } = useTranslation('pages/pageInterwill', { keyPrefix: 'deleteTheWillModal' });
  const modals = useModalsStore();

  const handleSubmit = () => {
    modals.closeModal();
    onDelete();
  };

  return (
    <ModalContainerV2 title={t('title')} pinBottom={true}>
      <DescriptionWrapper>{t('description')}</DescriptionWrapper>
      <ButtonWrapper>
        <ButtonStyled type="default" onClick={modals.closeModal}>
          {t('cancelButton')}
        </ButtonStyled>

        <ButtonError onClick={handleSubmit}>{t('confirmButton')}</ButtonError>
      </ButtonWrapper>
    </ModalContainerV2>
  );
};

const DescriptionWrapper = styled.div`
  padding: 24px 0px;
  white-space: pre-line;
  font-size: 14px;

  ${media.mobile} {
    padding: 16px 0px 10px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  gap: 16px;
`;

const ButtonStyled = styled(ButtonIw)`
  && {
    font-weight: 700;
  }
`;

const ButtonError = styled(ButtonStyled)`
  && {
    background: ${COLORS.systemFlame200};

    &&:hover {
      background: ${COLORS.systemFlame300};
    }
  }
`;
